import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const FolderForm_Folder_Update_Mutation = graphql(`
  mutation FolderForm_Folder_Update(
    $id: Id!
    $update: FolderInput!
    $versionData: VersionDataInput
  ) {
    updateFolder(id: $id, update: $update, versionData: $versionData) {
      _id
    }
  }
`);

export type FolderForm_Folder_Update_Result = ResultOf<
  typeof FolderForm_Folder_Update_Mutation
>;

export const useUpdateFolderMutation = () =>
  useGraphQLMutation(FolderForm_Folder_Update_Mutation);
